<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Survey</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link>
      /
      <b>Marketing</b>
      /
      <router-link :to="{name: 'survey-view'}">Survey</router-link>
      /
      <router-link :to="{name: 'survey-view'}">List</router-link>
      /
      <b>User's Answer</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="row mb-3">
        <div class="col-12 col-lg-6 col-sm-12">
        </div>

        <div class="col-12 col-lg-6 col-sm-12 d-flex flex-column flex-sm-row align-items-center">
            <span class="m-auto"></span>
            <div class="btn-group" role="group">
              <!-- <button class="btn btn-secondary" id="btn-active" type="button" :class = "{ 'change-background' : activeClick }" @click="clickActive()" >Active</button>
              <button class="btn btn-secondary" id="btn-inactive" type="button" :class = "{ 'change-background' : inactiveClick }" @click="clickInactive()">Inactive</button> -->
            </div>
        </div>
        
    </div>

    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- Active -->
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">User Survey Answer</h4>
            <div v-for="(list, index) in lists" :key="index">
              <label>Question: {{ list.question }}</label>
              <br />
              <label v-if="!checkifArray(list.answer)" class="mb-4">Answer(s): {{ checkAnswer(list.answer) }}</label>
              <label v-else class="mb-4">Answer(s): <span v-for="(ans, ansIndex) in list.answer" :key="ansIndex"> {{ans}} </span></label>
              <br />
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>


<script>
// @ is an alias to /src
import axios from "axios";

export default {
  name: "view-user-answer",
  components: {},

  data() {
    return {
      lists: []
    };
  },

  methods: {
    async loadQuestionAnswer() {
      let id = this.$route.params.id;
      let user_id = this.$route.params.user_id;
      if(!this.loadToken()) {
        return;
      }
      try {
        let result = await axios.post(axios.lpsURL + "/survey_user",
        {
          survey_id: id,
          user_id: user_id
        },
        {
          headers: {
            Authorization: "Bearer " + this.loadToken()
          }
        })
        console.log(JSON.stringify(result.data))
        this.lists = result.data.answers;
      } catch (error) {
        console.log(error)
      }
    },

    async loadData() {
      await this.loadQuestionAnswer()
    },

    loadToken() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token === null) {
        return false;
      }
      token = JSON.parse(token);
      token = token.access_token;
      return token;
    },

    checkifArray(str) {
      if(Array.isArray(str)) {
        return true
      }
      return false;
    },

    checkAnswer(str) {
      if(!Array.isArray(str)) {
        return str;
      }

      for(let i = 0; i < str.length; i++) {
        return str[i]
      }

    }
  },

  async created() {
    this.loadQuestionAnswer()
  },

  mounted() {}
};
</script>

